exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cwSplitBoxItem .input-group[data-v-ac9601c4]{position:relative;display:table;border-collapse:separate}.cwSplitBoxItem input[data-v-ac9601c4]{border:0;width:40%;background:none;font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif;font-size:.8125rem;color:#fff;color:#00646e;text-align:right}", ""]);

// exports
